import { render, staticRenderFns } from "./RolePermissionAddDialog.vue?vue&type=template&id=56de5e5d&scoped=true"
import script from "./RolePermissionAddDialog.vue?vue&type=script&lang=js"
export * from "./RolePermissionAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de5e5d",
  null
  
)

export default component.exports